
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Connection } from '@/types';
import EditDoganeDialog from '@/components/connections/EditDoganeDialog.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

@Component({
  components: {
    EditDoganeDialog,
  },
})
export default class ConnectionDogane extends Mixins(UtilsMixin) {
  @Prop(Object) readonly connection!: Connection;

  loading = false
  editDialog = false

  get isDisabled() {
    return this.loading;
  }

  get praticaDogane(): string | null {
    return this.connection?.praticaDogane ?? null;
  }

  get displayContent(): string | null {
    const raw = this.connection?.doganeElettricoNotes || null;
    if (!raw) return null;
    return raw.replace(/<\/?p>/gi, '').trim() || null;
  }

  get linkClass(): string {
    if (this.isDisabled) return 'grey--text text--lighten-2';
    if (this.praticaDogane === 'na') return 'link grey--text text--darken-2';
    return this.displayContent
      ? 'link'
      : 'link grey--text text--lighten-2';
  }

  get columnClass(): string {
    if (this.praticaDogane === 'na') return 'not-applicable';
    if (this.praticaDogane === 'done') return 'completed';
    if (this.praticaDogane === 'waiting') return 'warning';
    return '';
  }

  async onEdit() {
    if (this.loading || this.isDisabled) return;

    if (this.connection) {
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}
